import { render } from "./AuthInfo.vue?vue&type=template&id=060077b0&ts=true"
import script from "./AuthInfo.vue?vue&type=script&lang=ts"
export * from "./AuthInfo.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__